const React = require('react')
const PropTypes = require('prop-types')
const getFacebookSdk = require('lib/facebook_sdk')
const log = require('log').create('video', 'facebook') // eslint-disable-line

// facebook example
// https://www.facebook.com/natgeo/videos/vl.1887467314909998/10154808512288951

class FacebookVideo extends React.Component {

    componentDidMount() {
        this.parseFacebookMarkup()
    }

    componentDidUpdate() {
        this.parseFacebookMarkup()
    }

    parseFacebookMarkup() {
        // https://developers.facebook.com/docs/reference/javascript/FB.XFBML.parse/
        getFacebookSdk().then(FB => {
            FB.XFBML.parse()
        })
    }

    render() {
        const { type, url } = this.props.video
        if (type !== 'facebook') return null
        if (! url) return null

        return (
            <div className="video-wrapper facebook">
                <div
                    className="fb-video"
                    data-href={url}
                    data-show-text="false"
                    data-allowfullscreen={true}
                    >
                </div>
            </div>
        )
    }

}

FacebookVideo.propTypes = {
    video: PropTypes.object.isRequired,
}

module.exports = FacebookVideo
